import {
	appEntitlementRootSaga,
	AuthConfig,
	authTokenRootSaga,
	EnvironmentService,
	extendedEntitlementRootSaga,
	initializeMitchellEnvironment,
	orgRootSaga,
	userRootSaga,
	jobListRootSaga, 
	fileRootSaga, 
	jobDocumentRootSaga, 
	jobAttachmentsManagerRootSaga,
	IAuthService,
	AuthService,
	IAuthState,
	repairCenterRootSaga
} from '@mitchell/redux.module.apd';

initializeMitchellEnvironment();

const env = EnvironmentService.getEnvironment();

// Refresh token 1min before it expires
const refreshBufferInMilliseconds: number = 1 * 1000 * 60;

const authConfig: AuthConfig = {
	clientId: env.clientId,
	clientSecret: env.clientSecret,
	reducerKey: 'domain.auth',
	oAuthUrl: env.authentication,
	refreshBufferInMilliseconds,
	applicationLoginUrl: env.repairCenterMobileUrl,
	onAuthRetryMaxExceeded:(maxRetryCount: number, _authState: IAuthState, authConfig: AuthConfig): void => {
		const authService: IAuthService = AuthService.getInstance(authConfig);
		authService.deleteTokens();
		window.location.assign(env.repairCenterMobileUrl);
	}
};

export const rootSagaEffects = [
	authTokenRootSaga(authConfig),
	orgRootSaga,
	userRootSaga,
	appEntitlementRootSaga,
	extendedEntitlementRootSaga,
	jobListRootSaga,
	fileRootSaga, 
	jobDocumentRootSaga, 
	jobAttachmentsManagerRootSaga,
	repairCenterRootSaga
];
